import {createSelector} from "@reduxjs/toolkit";
import {RootState} from "../../app/store";

export const ModalSelector = createSelector(
    (state: Pick<RootState, "response">) => state.response.isOpen,
    (isOpen) => isOpen
);
